import 'css-chunksrc/client/scenes/resourceEdition/assignCostProfileToResource/selectedProfile/styles.scss';export default {
  "selectedProfile": "_selectedProfile_1wgsx_1",
  "name": "_name_1wgsx_13",
  "cost": "_cost_1wgsx_19",
  "icon": "_icon_1wgsx_24"
};